









import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

@Component({
  components: {
  }
})
export default class ImageItem extends Vue {

   @Prop() private image!: def.Image;
   @Prop() private isSelected!: boolean;

    select()
    {
        this.$emit("selectImage" , this.image);
    }

    decide(){
        this.select();
        this.$emit("decideImage")
    }

    private get imageSrc(): string {
        return this.image.imageData || this.image.imagePath;
    }

    private get userConfigBorderColorStyle(){
        var style = {
            border : "solid 3px" + this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
